var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"block"},[_c('div',{class:['box is-paddingless', _vm.$style.container]},[_c('table',{staticClass:"table is-fullwidth"},[_c('thead',[_vm._t("header")],2),_c('tbody',[_vm._t("body")],2),_c('tfoot',[_vm._t("footer")],2)])])])
}
var staticRenderFns = []

export { render, staticRenderFns }